export const labelListStyle = (fill) => ({
  textAnchor: "middle",
  fontSize: "12px",
  fontWeight: "bold",
  textShadow: "0 0 6px #ffffff, 0 0 3px #ffffff",
  fill,
});
